export default __webpack_public_path__ + "static/media/Hub_LED.a31a818b.png";